import Icon from '../components/Icon.vue'

Icon.register({
  cookie: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.4 254.8c4.4 27.7-0.1 56-12.8 81l-35.1 68.9c-10.8 21.1-36.7 47-57.8 57.8l-69.1 35.2c-24.8 12.6-53 17.1-80.5 12.8l-76.7-12.1c-23.4-3.7-56-20.3-72.7-37l-54.8-54.8c-16.8-16.8-33.4-49.5-37.2-73l-12.1-76.3c-0.9-5.7-1.6-15-1.6-20.7 0-17.6 6.5-44.5 14.5-60.2l35.1-68.9c10.8-21.1 36.7-47 57.8-57.8l69.1-35.2c24.8-12.6 53-17.1 80.5-12.8l76.7 12.2c27.5 4.3 53 17.3 72.7 37l54.8 54.8c16.8 16.8 33.4 49.5 37.2 73zM176 368c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM208 208c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM368 336c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cookie.js
// module id = 1240
// module chunks = 0